// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2YSml","inputDescription":"styles_inputDescription__2ETq1"};